export default "__VITE_ASSET__mMXAVY5G__";